
// When using following function, make sure to check data for success, usually a success key
// do not rely on promise resolve
export const apiWrapWithErrorWithData = (apiPromise) =>
  new Promise((resolve) => {
    apiPromise
      .then((res) => {
        if (res.status === 401) {
          // TODO
        }

        return resolve(res);
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          // TODO
        }

        if (error.response) {
          resolve(error.response.data);
        } else {
          resolve(undefined);
        }
      });
  });
